import { type HttpGet, mapServerError } from '@/shared/infra/http'
import type {
  ListUnmatchedQrSignatures,
  ListUnmatchedQrSignaturesResult,
} from '@/shared/domain'

export class EdgeListUnmatchedQrSignaturesRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListUnmatchedQrSignatures = async ({ templateId, limit, offset }) => {
    const search = new URLSearchParams()
    if (limit !== undefined) search.set('limit', String(limit))
    if (offset !== undefined) search.set('offset', String(offset))
    const qs = search.toString()
    try {
      return await this.http.get<ListUnmatchedQrSignaturesResult>({
        url: `/waivers/${encodeURIComponent(templateId)}/qr-signatures/unmatched${qs ? `?${qs}` : ''}`,
      })
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
